import { appEnv } from "@/constants/app-env";
import { env } from "@/constants/env";
import ReactPixel from "react-facebook-pixel";

export const initializeFBPixel = () => {
  ReactPixel.init(env.PIXEL_ID, undefined, {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
  });
};

export const trackPixelReservedEvent = (
  event: "Lead" | "AddPaymentInfo" | "ViewContent" | "CompleteRegistration" | "AddToWishlist",
  data?: Record<string, unknown>,
) => {
  ReactPixel.track(event, data);

  if (appEnv.isDevelopment) {
    console.log("[PIXEL EVENT]", event, data);
  }
};
